import { Dispatch } from '@reduxjs/toolkit';
import axiosInstance, { ApiKeys, getApiUrl, logError } from '../../../utils/ApiHelper';
import { STORE_KEYS } from '../constants';
import {
  setCaseDetail,
  setCaseDetailError,
  setCaseDetailLoading
} from '../reducers/caseDetailSlice';
import { IPastFeedbacksOnAddressesPayload } from '../components/TopAddresses/interfaces';

export const fetchTopAddresses =
  (lan: string, customerRefrenceId: string, caseReferenceId: string) => (dispatch: Dispatch) => {
    const url = getApiUrl(ApiKeys.TOP_ADDRESSES);
    dispatch(
      setCaseDetailLoading({
        lan,
        customerRefrenceId,
        key: STORE_KEYS.TOP_ADDRESSES,
        loading: true
      })
    );

    axiosInstance
      .get(url, {
        params: {
          caseReferenceId
        }
      })
      .then(response => {
        dispatch(
          setCaseDetail({
            lan,
            customerRefrenceId,
            key: STORE_KEYS.TOP_ADDRESSES,
            data: response.data
          })
        );
      })
      .catch(err => {
        dispatch(
          setCaseDetailError({
            lan,
            customerRefrenceId,
            key: STORE_KEYS.TOP_ADDRESSES,
            error: err
          })
        );
      });
  };

export const getPastFeedbacksOnAddresses = (
  pastFeedbackPayload: IPastFeedbacksOnAddressesPayload
) => {
  const url = getApiUrl(ApiKeys.GET_PAST_FEEDBACKS_ON_ADDRESSES);

  return axiosInstance
    .get(url, {
      params: pastFeedbackPayload,
      headers: {
        'X-Feedback-Source': 'ADDRESS'
      }
    })
    .then(response => {
      if (response?.data) {
        return {
          data: response?.data?.data || []
        };
      }
    })
    .catch(err => {
      logError(err);
    });
};

export const updateRecentActivity = async (
  customerReferenceId: string,
  addressId: string,
  recentActivityDate: string
): Promise<void> => {
  const apiUrl = getApiUrl(ApiKeys.UPDATE_RECENT_ACTIVITY, { customerReferenceId, addressId });

  try {
    await axiosInstance.patch(apiUrl, {
      recentActivityDate
    });
  } catch (err) {
    logError(err, 'Failed to update recent activity');
    throw err;
  }
};
